import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface UpdateFileParams {
  categoryId?: string;
  eocId?: string;
  file?: File;
  file_name?: string;
}

interface UpdateFileResponse {
  documentReference: fhirTypes.DocumentReference;
}

export const useUpdateFile = (
  patientId: string,
  documentReferenceId?: string,
) => {
  const queryClient = useQueryClient();

  return useApiMutation<UpdateFileResponse, UpdateFileParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Files.UPDATE(
        patientId,
        documentReferenceId,
      ),
      mutationFn: (params) => {
        const formData = new FormData();
        if (params.file) formData.append("file", params.file);
        if (params.categoryId) formData.append("categoryId", params.categoryId);
        if (params.eocId) formData.append("eocId", params.eocId);
        if (params.file_name) formData.append("file_name", params.file_name);

        return axiosInstance.patch(
          `/charting/files/document-reference/${documentReferenceId}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Files.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Files.DEFAULT({ patientId }),
        });
      },
    },
  });
};
